import React from "react";
import MovieList from "../movieList/movieList";
import { connect } from "react-redux";
import NotFound from "../notFound/notFound";

const Favorites = ({ favorites }) => {
  if (favorites.length === 0) {
    return <NotFound />;
  }
  return <MovieList movies={favorites} />;
};

const mapState = state => {
  return {
    favorites: state.favorites.favorites
  };
};

export default connect(mapState)(Favorites);
